import { ExportAppEndAction } from "../actions/ExportApp";
import { AppState } from "../state";

export function exportApp(state: AppState, action: ExportAppEndAction): AppState {
    return { ...state, exportContent: action.payload.content };
}
